module.exports = __webpack_public_path__ + "img/SelectiveFocus.3d61100b.png";